module.exports = __webpack_public_path__ + "static/media/AD-Fish_jumpup.6b46d03e.png";